import { useContext } from 'react';

import type { PrismItem } from './types';
import type { FeatureName } from '@monorepo/paytron-payments2/app/src/common/prism/prism.types';

import { BackendAccessContext } from 'Backend';
import { getCurrentCompanyId } from 'Lib/Utils';

const pricingTiers = ['freeTier', 'basicTier', 'premiumTier'] as const;

type Item = { [index: string]: unknown } & PrismItem;

export const usePrism = () => {
    const CompanyId = getCurrentCompanyId();
    const { prism, isPrismLoading } = useContext(BackendAccessContext);

    const hasFeatureEnabled = (featureName: FeatureName, companyId?: string) => {
        const prismItem: Item | undefined = prism[featureName];

        const companyHasFeature = prismItem?.companies?.includes(companyId || CompanyId);
        const featureIsInTier = pricingTiers.find((pt) => prismItem?.[pt]);
        const featureIsInBeta = companyHasFeature && prismItem?.beta;
        const featureIsPublic = prismItem?.public;

        return !!featureIsInBeta || !!featureIsInTier || !!featureIsPublic;
    };

    return {
        isPrismLoading,
        hasFeatureEnabled,
    };
};
